export class Vec2 {
    constructor(x, y) {
        this.x = x;
        this.y = y;
    }
    getAsObj() {
        return {
            x: this.x,
            y: this.y,
        };
    }
}
